import { render } from "./NewReview.vue?vue&type=template&id=04606319&scoped=true"
import script from "./NewReview.vue?vue&type=script&lang=ts"
export * from "./NewReview.vue?vue&type=script&lang=ts"

import "./NewReview.vue?vue&type=style&index=0&id=04606319&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04606319"

export default script